import React, { useMemo, useState } from "react";
import { SectionWrapper } from "../components/SectionWrapper";
import { IState } from "../features/profileAccountHook";
import { termsAndConditionsTypeLabels } from "../const";
import { Button } from "../components/Button";
import ArrowIcon from "../icons/arrow-icon.svg";
import TickCircleIcon from "../icons/tick-circle.svg";
import { NdaModal } from "../components/NdaModal";
import { updateNestedObjectMulti } from "../utils";
import ProfileService from "@services/Profile.service";
import { useAccountPageContext } from "../AcountPage.context";

const paths = require("../paths");

type AgreementsAndTermsProps = {
  fetchProfileData: () => void;
};

export const AgreementsAndTerms = ({
  fetchProfileData,
}: AgreementsAndTermsProps) => {
  const { state } = useAccountPageContext();

  const [showNda, setShowNda] = useState<boolean>(false);

  const sortedTermsAndCondition = useMemo(
    () =>
      state.terms_and_conditions.sort((a, b) => {
        if (a.type === "staking") return 1;
        if (b.type === "staking") return -1;
        return 0;
      }),
    [state.terms_and_conditions]
  );

  const toggleNdaPreview = (
    event?: React.MouseEvent<HTMLSpanElement>
  ): void => {
    if (event) {
      event.preventDefault();
    }

    setShowNda(!showNda);
  };

  const onNdaAgreementChange = (): void => {
    const ndaAgreementPath = paths.profileDataAgreements("nda_accepted");
    const updatedProfileData = updateNestedObjectMulti(state.profileData, [
      {
        path: ndaAgreementPath,
        value: true,
      },
    ]);

    ProfileService.updateProfileData(updatedProfileData).then(() => {
      fetchProfileData();
      toggleNdaPreview();
    });
  };

  return (
    <>
      <SectionWrapper title="Confidentiality">
        <div className="flex justify-between items-center bg-grey-light border border-grey-lighter p-8 rounded-[10px]">
          <div>
            <div className="font-semibold">Non-Disclosure Agreement</div>
            <div className="text-sm">
              Review NDA{" "}
              <a onClick={toggleNdaPreview} className="underline">
                here
              </a>
            </div>
          </div>

          {state.profileData.agreements.nda_accepted && (
            <div className="flex items-center gap-2 text-sm font-semibold px-[15px] py-[7px] border border-[#23B664] text-[#23B664] bg-white rounded-[8px]">
              Accepted <TickCircleIcon />
            </div>
          )}
        </div>
      </SectionWrapper>

      <SectionWrapper title="Terms and conditions">
        <div className="flex flex-col gap-4">
          {sortedTermsAndCondition.map((term) => (
            <div className="flex justify-between items-center bg-grey-light border border-grey-lighter p-8 rounded-[10px]">
              <div className="font-semibold">
                {termsAndConditionsTypeLabels[term.type]}
              </div>

              <Button
                className="h-[36px] flex gap-2 items-center"
                isPrimary
                href={`/terms_and_conditions/${term.type}`}
                target="_blank"
              >
                View <ArrowIcon />
              </Button>
            </div>
          ))}
        </div>
      </SectionWrapper>

      <NdaModal
        ndaChecked={state.profileData.agreements.nda_accepted}
        open={showNda}
        onClose={toggleNdaPreview}
        onUpdateNdaAgreement={onNdaAgreementChange}
      />
    </>
  );
};
